import { useEffect, useState } from "react";

// Persisted column-visibility preferences. `columns` is [{ key, label }].
export function useColumns(storageKey, columns) {
  const allKeys = columns.map((c) => c.key);
  const [visible, setVisible] = useState(() => {
    try { const s = JSON.parse(localStorage.getItem(storageKey)); if (Array.isArray(s)) return s.filter((k) => allKeys.includes(k)); } catch { /* ignore */ }
    return allKeys;
  });
  useEffect(() => { localStorage.setItem(storageKey, JSON.stringify(visible)); }, [storageKey, visible]);
  const isOn = (k) => visible.includes(k);
  const toggle = (k) => setVisible((v) => (v.includes(k) ? v.filter((x) => x !== k) : [...v, k]));
  const reset = () => setVisible(allKeys);
  return { isOn, toggle, reset, visible };
}
